import Vue from 'vue';
import router from '../router';

export default function handleErrors(message, to) {
  if (to) {
    router.push({ name: to });
  }

  Vue.prototype.toast.error(message, 'Error', {
    position: 'topCenter',
    transitionIn: 'fadeInDown',
    transitionOut: 'fadeOutUp',
    transitionInMobile: 'fadeInDown',
    transitionOutMobile: 'fadeOutUp',
    timeout: 4000,
    progressBar: false
  });
}



// WEBPACK FOOTER //
// src/utils/handler-errors.js